import React, { useEffect, useState } from "react";
import axios from "../../axios";
import { toast } from "react-toastify";

const EditCountry = (props) => {
  const [country, addcountry] = useState({});
  const [imageData, setimageData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const countryName = (e) => {
    console.log(e);
    const ud = Object.assign({}, country);
    ud.name = e.target.value;
    addcountry(ud);
  };

  const countryCode = (e) => {
    console.log(e);
    const ud = Object.assign({}, country);
    ud.code = e.target.value;
    addcountry(ud);
  };

  const phoneCode = (e) => {
    console.log(e);
    const ud = Object.assign({}, country);
    ud.phone_code = e.target.value;
    addcountry(ud);
  };

  const getCurrentCountry = () => {
    axios
      .get("countries/id?id=" + props.match.params.id)
      .then((data) => {
        addcountry(data.data);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      });
  };

  useEffect(() => {
    getCurrentCountry();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!country.image_url && !imageData?.image) {
      toast.error("Please upload country image");
      return;
    }

    if (submitting) {
      return;
    }

    setSubmitting(true);
    const formData = new FormData();
    formData.append("id", country.id);
    formData.append("name", country.name);
    formData.append("code", country.code);
    formData.append("phone_code", country.phone_code);
    if (imageData?.image) {
      formData.append("image", imageData.image);
    }

    axios
      .put("countries/", formData)
      .then((data) => {
        console.log(data.data);
        toast.success("Country has been edited successfully!");
        window.history.back();
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const imageDataChange = (e) => {
    const ud = Object.assign({}, imageData);
    ud.image = e.target.files[0];
    setimageData(ud);
    console.log("fajllimrena", imageData);
  };

  return (
    <div className="editcities p-5 text-left">
      <div className="row">
        <h1>Edit country</h1>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row p-3">
          <img
            src={
              imageData?.image
                ? URL.createObjectURL(imageData.image)
                : `${process.env.REACT_APP_UPLOADS + country.image_url}`
            }
            alt="Country Image"
            style={{ maxWidth: "100%", height: "300px", objectFit: "contain" }}
          />
        </div>
        <input
          type="file"
          title="This field is required"
          name="image"
          onChange={imageDataChange}
        ></input>
        <input
          type="text"
          required
          title="This field is required"
          placeholder="Country Name"
          onChange={countryName}
          value={country.name}
        ></input>
        <input
          type="text"
          required
          title="This field is required"
          placeholder="Country Code"
          onChange={countryCode}
          value={country.code}
        ></input>
        <input
          type="text"
          required
          title="This field is required"
          placeholder="Phone Prefix"
          onChange={phoneCode}
          value={country.phone_code}
        ></input>

        <button type="submit" className="buttonAction" disabled={submitting}>Edit country</button>
      </form>
    </div>
  );
};
export default EditCountry;
